var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "terms" }, [
    _c("header", { staticClass: "terms__header" }, [
      _c("div", { staticClass: "header__content" }, [
        _c("span", [_vm._v(_vm._s(_vm.recipe.name))]),
        _vm._v(" "),
        _c("h2", [_vm._v(_vm._s(_vm.recipe.data.title))]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            _vm._s(_vm.recipe.data.calories) +
              " " +
              _vm._s(_vm.$t("profile.home.recipeStats")) +
              " / " +
              _vm._s(_vm.recipe.data.time)
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "img",
          on: {
            click: function($event) {
              return _vm.$emit("close")
            }
          }
        },
        [
          _c("img", {
            attrs: {
              src: "/media/inpulse-template-ac-new-a/profile/close.svg",
              alt: "close"
            }
          })
        ]
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "recipe__data" }, [
      _c("div", { staticClass: "img" }, [
        _c("img", { attrs: { src: _vm.recipe.data.image, alt: "" } })
      ]),
      _vm._v(" "),
      _c("h3", [_vm._v(_vm._s(_vm.$t("profile.recipes.ingredients")) + ":")]),
      _vm._v(" "),
      _c(
        "ul",
        _vm._l(_vm.recipe.data.ingredients, function(ingredient) {
          return _c("li", { key: ingredient }, [_vm._v(_vm._s(ingredient))])
        }),
        0
      ),
      _vm._v(" "),
      _c("h3", [
        _vm._v(_vm._s(_vm.$t("profile.recipes.methodPreparation")) + ":")
      ]),
      _vm._v(" "),
      _c(
        "ol",
        _vm._l(_vm.recipe.data.steps, function(step) {
          return _c("li", { key: step }, [_vm._v(_vm._s(step))])
        }),
        0
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }